import { DroplistItem } from '@eforall/dashboard';
import { StaticDataService } from '../../../../services';


export function getDatasetItems(staticData: StaticDataService): DroplistItem<unknown, number>[] {

	const datasets = staticData.datasets.all
		.map(d => ({ ...d, category: staticData.dataset_categorys.byId(d.datasetCategoryId) }))
		.sort((a, b) => {
			
			//
			// Sort by category.sortOrder (asc)
			//
			if (a.category.sortOrder !== b.category.sortOrder) {
				return a.category.sortOrder - b.category.sortOrder;
			}

			//
			// Sort by category.name (asc)
			//
			const categoryNameSort = a.category.name.localeCompare(b.category.name);
			if (categoryNameSort !== 0) {
				return categoryNameSort;
			}

			//
			// Sort by item.name (asc)
			//
			return a.name.localeCompare(b.name);
		});


	const items: DroplistItem<unknown, number>[] = datasets.map(d => {

		return {
			uniqueId: d.id,
			iconContext: { iconClass: 'fa-table', iconStyle: 'fa-regular', text: d.name, hideText: 'never' },
			groupName: d.category.name,
			customSort: d.name,
		}
	});

	return items;
}